<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <div class="header-topic">
            <h4><i class="fas fa-boxes"></i> จัดการสต๊อก</h4>
          </div>

          <b-card no-body>
            <b-tabs
              card
              v-model="activeTabIndex"
            >
              <b-tab
                v-for="tab in statusTabs"
                :key="tab.status"
              >
                <template #title>
                  {{ tab.label }}{{ tab.showCount ? ` (${tab.count})` : "" }}
                  <span
                    v-if="
                      tab.showRedDot &&
                      tab.count > 0 &&
                      tab.redDotRole &&
                      isAccessMenu([tab.redDotRole]) &&
                      (!tab.excludeIfRole || !isAccessMenu([tab.excludeIfRole]))
                    "
                    class="tab-red-dot"
                  ></span>
                </template>
                <div
                  class="row"
                  style="margin: 0px 0px 20px 0px"
                >
                  <b-form-input
                    type="search"
                    class="col"
                    autofocus
                    v-model="filter"
                    placeholder="ค้นหาการจัดการสต๊อก จากรหัส ประเภทการจัดการ หรือชื่อผู้ทำรายการ"
                  ></b-form-input>
                  <b-button
                    class="w-full ml-3 outline-btn"
                    variant="outline-secondary"
                    @click="handleExportExcel"
                    v-if="isStockManagerOrStaff"
                  >
                    <i class="fas fa-file-download"></i> ดาวน์โหลดข้อมูลสต๊อก
                  </b-button>
                  <b-button
                    class="w-full ml-3 outline-btn"
                    variant="outline-secondary"
                    @click="triggerFileInput"
                    v-if="isStockManagerOrStaff"
                  >
                    <i class="fas fa-file-upload"></i> ตรวจนับสต๊อกจากไฟล์
                  </b-button>
                  <b-button
                    class="w-full ml-3 btn-adjust-disabled"
                    variant="primary"
                    @click="openStockAdjustmentModal()"
                    v-if="isStockManagerOrStaff"
                  >
                    <i class="fas fa-pencil-square-o"></i> ปรับปรุงสต๊อก
                  </b-button>
                </div>
                <b-table
                  id="stockManagementTable"
                  ref="stockManagementTable"
                  hover
                  small
                  sort-icon-left
                  :sort-by="'dateTimeStock'"
                  head-variant="light"
                  :items="filteredStockAdjustmentList"
                  :fields="fields"
                  :sort-desc="true"
                  :responsive="false"
                >
                  <template v-slot:cell(index)="row">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      {{ row.index + 1 }}.
                    </div>
                  </template>
                  <template v-slot:cell(normalizedStatus)="row">
                    <AdjustmentStatusBadge
                    :status="row.item.normalizedStatus"
                    />
                  </template>
                  <template v-slot:cell(adjNo)="row">
                    {{ row.item.adjNo }}
                  </template>
                  <template v-slot:cell(type)="row">
                    {{ row.item.type }}
                  </template>
                  <template v-slot:cell(managedByStock)="row">
                    <div
                      class="ellipsis-text"
                      :title="row.item.managedByStock"
                    >
                      {{ row.item.managedByStock }}
                    </div>
                  </template>
                  <template v-slot:cell(button)="row">
                    <ActionButtonGroup
                      :item="row.item"
                      compact
                      :showEdit="
                        row.item.normalizedStatus ===
                          ADJUSTMENT_STATUS.WAITING_BM ||
                        row.item.normalizedStatus === ADJUSTMENT_STATUS.REJECTED
                      "
                      :show-delete="
                        row.item.normalizedStatus ===
                          ADJUSTMENT_STATUS.WAITING_BM ||
                        row.item.normalizedStatus === ADJUSTMENT_STATUS.REJECTED
                      "
                      :disabled-edit="!!row.item.syncDt"
                      :disabled-delete="!!row.item.syncDt"
                      info-tooltip="ดูข้อมูลการจัดการสต๊อก"
                      edit-tooltip="แก้ไขการจัดการสต๊อก"
                      delete-tooltip="ยกเลิกการจัดการสต๊อก"
                      @info="goToStockManagementDetail(row.item.id)"
                      @edit="openStockAdjustmentEditModal(row.item)"
                      @delete="deleteStockAdjustment(row.item)"
                    />
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </b-card>
          <input
            ref="fileInput"
            type="file"
            accept=".xlsx,.xls"
            style="display: none"
            @change="handleImportExcel"
          />
        </div>
      </div>
      <StockAdjustmentModal
        ref="stockAdjustmentModal"
        @stock-adjusted="handleStockAdjusted"
      ></StockAdjustmentModal>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { ROLES } from "@/constants/user";
import BigNumber from "bignumber.js";
import { mapActions, mapGetters } from "vuex";
import Dialog from "../../components/modal/Dialog.vue";
import StockAdjustmentModal from "../../components/modal/ProductAndStock/StockAdjustment.vue";
import { Status, ADJUSTMENT_STATUS, STOCK_TYPE_NAME } from "../../constants/productStock";
import { formatDate } from "../../utils/utils";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";
import AdjustmentStatusBadge from "@/components/badge/ProductAndStock/AdjustmentStatusBadge.vue";
import tabQueryMixin from "@/mixins/tabQueryMixin";

export default {
  name: "StockManagement",
  mixins: [tabQueryMixin],
  tabQuery: {
    keys: ["WAITING_BM", "WAITING_HQ", "REJECTED", "COMPLETED", "CANCELED"],
    model: "activeTabIndex",
  },
  components: {
    StockAdjustmentModal,
    Dialog,
    Loading,
    ActionButtonGroup,
    AdjustmentStatusBadge,
  },
  data() {
    return {
      ROLES,
      ADJUSTMENT_STATUS,
      isLoading: false,
      filter: "",
      activeTabIndex: 0,
      Status,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getProductList: "moduleProductInventory/getProductList",
      getStockAdjustmentList: "moduleProductInventory/getStockAdjustmentList",
      getProductUnitList: "moduleUnitMaster/getUnitList",
      getAllGRWithProductList: "moduleProductInventory/getAllGRWithProductList",
      isAccessMenu: "moduleUser/getIsAccessMenu",
    }),
    isStockManager() {
      return this.isAccessMenu([ROLES.ROLE_BRANCH_STOCK_MANAGER]);
    },
    isStockManagerOrStaff() {
      return this.isAccessMenu([
        ROLES.ROLE_BRANCH_STOCK_MANAGER,
        ROLES.ROLE_STOCK_STAFF,
      ]);
    },
    fields() {
      const baseFields = [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "normalizedStatus",
          label: "สถานะ",
          thStyle: { width: "16%" },
          tdStyle: { width: "16%" },
        },
        {
          key: "adjNo",
          label: "รหัส",
          sortable: true,
          thStyle: { width: "17%" },
          tdStyle: { width: "17%" },
          tdClass: "text-nowrap code-cell",
        },
        {
          key: "type",
          label: "ประเภทการจัดการ",
          sortable: true,
          thStyle: { width: "17%", padding: "8px" },
          tdStyle: { width: "17%", padding: "8px" },
        },
        {
          key: "managedByStock",
          label: "ชื่อผู้ทำรายการ",
          sortable: true,
          thStyle: { width: "16%", padding: "8px" },
          tdStyle: { width: "16%", padding: "8px" },
        },
        {
          key: "transactionDt",
          label: "วันที่มีผล",
          sortable: true,
          formatter: value => (value ? formatDate(value) : "-"),
          sortByFormatted: false,
          thStyle: { width: "13%", padding: "8px" },
          tdStyle: { width: "13%", padding: "8px" },
        },
        {
          key: "dateTimeStock",
          label: "วันที่ทำรายการ",
          sortable: true,
          formatter: value => (value ? formatDate(value) : ""),
          sortByFormatted: false,
          thStyle: { width: "13%", whiteSpace: "nowrap" },
          tdStyle: { width: "13%", whiteSpace: "nowrap" },
        },
        {
          key: "button",
          label: "",
          class: "text-center",
          thStyle: { width: "10%", whiteSpace: "nowrap" },
          tdStyle: { width: "10%", whiteSpace: "nowrap" },
        },
      ];

      return baseFields;
    },
    productList() {
      return this.getProductList || [];
    },
    sortedStockAdjustmentList() {
      return [...(this.getStockAdjustmentList || [])]
        .map(item => ({
          ...item,
          normalizedStatus: this.normalizeAdjStatus(item.status),
          managedByStock: [
            item.creationUser?.firstNameTh,
            item.creationUser?.lastNameTh,
          ]
            .filter(Boolean)
            .join(" "),
          dateTimeStock: item.creationDt || "",
          type: this.getAdjustmentDetail(item.type),
        }))
        .sort(
          (a, b) =>
            new Date(b.creationDt).getTime() - new Date(a.creationDt).getTime()
        );
    },
    activeStatus() {
      const order = [
        ADJUSTMENT_STATUS.WAITING_BM,
        ADJUSTMENT_STATUS.WAITING_HQ,
        ADJUSTMENT_STATUS.REJECTED,
        ADJUSTMENT_STATUS.COMPLETED,
        ADJUSTMENT_STATUS.CANCELED,
      ];
      return order[this.activeTabIndex] || ADJUSTMENT_STATUS.WAITING_BM;
    },
    statusTabs() {
      const tabs = [
        {
          status: ADJUSTMENT_STATUS.WAITING_BM,
          label: "รอผู้จัดการคลังอนุมัติ",
          showCount: true,
          showRedDot: true,
          redDotRole: ROLES.ROLE_BRANCH_STOCK_MANAGER,
        },
        {
          status: ADJUSTMENT_STATUS.WAITING_HQ,
          label: "รอสำนักงานใหญ่อนุมัติ",
          showCount: true,
        },
        {
          status: ADJUSTMENT_STATUS.REJECTED,
          label: "ถูกปฏิเสธ",
          showCount: true,
          showRedDot: true,
          redDotRole: ROLES.ROLE_STOCK_STAFF,
          excludeIfRole: ROLES.ROLE_BRANCH_STOCK_MANAGER,
        },
        {
          status: ADJUSTMENT_STATUS.COMPLETED,
          label: "อนุมัติแล้ว",
          showCount: false,
        },
        {
          status: ADJUSTMENT_STATUS.CANCELED,
          label: "ถูกยกเลิก",
          showCount: false,
        },
      ];
      return tabs.map(tab => ({
        ...tab,
        count: this.sortedStockAdjustmentList.filter(
          i => i.normalizedStatus === tab.status
        ).length,
      }));
    },
    filteredStockAdjustmentList() {
      const byStatus = this.sortedStockAdjustmentList.filter(
        i => i.normalizedStatus === this.activeStatus
      );
      const keyword = (this.filter || "").trim().toLowerCase();
      if (!keyword) return byStatus;
      return byStatus.filter(
        i =>
          (i.adjNo || "").toLowerCase().includes(keyword) ||
          (i.type || "").toLowerCase().includes(keyword) ||
          (i.managedByStock || "").toLowerCase().includes(keyword)
      );
    },
  },
  methods: {
    ...mapActions({
      fetchUnitList: "moduleUnitMaster/fetchUnitList",
      fetchProductList: "moduleProductInventory/fetchProductList",
      fetchStockAdjustmentList:
        "moduleProductInventory/fetchStockAdjustmentList",
      fetchStockAdjustmentById:
        "moduleProductInventory/fetchStockAdjustmentById",
      deleteStockAdjustmentAction:
        "moduleProductInventory/deleteStockAdjustment",
      fetchAllGRWithProductList:
        "moduleProductInventory/fetchAllGRWithProductList",
      exportStockAdjustmentFile:
        "moduleProductInventory/exportStockAdjustmentFile",
    }),
    async init() {
      this.isLoading = true;
      try {
        const clinicUrl = this.$route.params.clinicUrl;
        const branchUrl = this.$route.params.branchUrl;
        const promises = [
          this.fetchUnitList({ clinicUrl, branchUrl }),
          this.fetchProductList({ clinicUrl, branchUrl }),
          this.fetchStockAdjustmentList({ clinicUrl, branchUrl }),
        ];
        if (this.isStockManager) {
          promises.push(
            this.fetchAllGRWithProductList({ clinicUrl, branchUrl })
          );
        }
        await Promise.all(promises);
      } catch (err) {
        this.showDialogToast("danger", "โหลดรายการสินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    normalizeAdjStatus(status) {
      const remap = { PENDING: "WAITING_BM", CONFIRMED: "COMPLETED" };
      return remap[status] || status || "";
    },
    getAdjustmentDetail(docType) {
      switch (docType) {
        case STOCK_TYPE_NAME.GENERAL:
          return "ปรับปรุงทั่วไป";
        case STOCK_TYPE_NAME.RETURN:
          return "ส่งคืนสินค้า";
        case STOCK_TYPE_NAME.PHYSICAL_COUNT:
          return "ตรวจนับสต๊อก";
        case STOCK_TYPE_NAME.WITHDRAW:
          return "ตัดเบิกของ";
        default:
          return docType || "-";
      }
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    openStockAdjustmentModal() {
      this.$refs.stockAdjustmentModal.show({
        unitList: this.getProductUnitList,
      });
    },
    async openStockAdjustmentEditModal(item) {
      try {
        this.isLoading = true;
        const clinicUrl = this.$route.params.clinicUrl;
        const branchUrl = this.$route.params.branchUrl;

        const adjustmentDetail = await this.fetchStockAdjustmentById({
          clinicUrl,
          branchUrl,
          adjustmentId: item.id,
        });

        if (!adjustmentDetail) {
          this.showDialogToast(
            "danger",
            "รายการนี้ถูกลบไปแล้ว กรุณารีเฟรชหน้าเพื่ออัปเดตข้อมูล"
          );
          this.init();
          return;
        }

        this.$refs.stockAdjustmentModal.show({
          unitList: this.getProductUnitList,
          editData: adjustmentDetail,
        });
      } catch (err) {
        console.error("Failed to load stock adjustment for edit:", err);
        const errorMessage = err.response?.data?.errorMessage;
        let errorMsg =
          typeof errorMessage === "string"
            ? errorMessage
            : "โหลดข้อมูลสำหรับแก้ไขไม่สำเร็จ กรุณาลองใหม่";

        if (
          errorMsg === "ไม่พบข้อมูลการปรับปรุงสต๊อก" ||
          err.response?.status === 404
        ) {
          errorMsg = "รายการนี้ถูกลบไปแล้ว กรุณารีเฟรชหน้าเพื่ออัปเดตข้อมูล";
        }

        this.showDialogToast("danger", errorMsg);

        if (
          errorMsg === "รายการนี้ถูกลบไปแล้ว กรุณารีเฟรชหน้าเพื่ออัปเดตข้อมูล"
        ) {
          this.init();
        }
      } finally {
        this.isLoading = false;
      }
    },
    deleteStockAdjustment(item) {
      this.$refs.Dialog.showAlertConfirm(
        "ยกเลิกการจัดการสต๊อก ?",
        "คุณต้องการยกเลิกการจัดการสต๊อกนี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;

        this.deleteStockAdjustmentAction({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          adjustmentId: item.id,
        })
          .then(res => {
            if (res.status === 200) {
              this.init();
              this.showDialogToast("success", "ยกเลิกการจัดการสต๊อกสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;
            let errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ไม่สามารถยกเลิกการจัดการสต๊อกได้ กรุณาลองใหม่";

            if (
              errorMsg === "ไม่พบข้อมูลการปรับปรุงสต๊อก" ||
              err.response?.status === 404
            ) {
              errorMsg =
                "รายการนี้ถูกลบไปแล้ว กรุณารีเฟรชหน้าเพื่ออัปเดตข้อมูล";
            }

            this.showDialogToast("danger", errorMsg);

            if (
              errorMsg ===
              "รายการนี้ถูกลบไปแล้ว กรุณารีเฟรชหน้าเพื่ออัปเดตข้อมูล"
            ) {
              this.init();
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    goToStockManagementDetail(adjustmentId) {
      this.$router.push({
        name: "StockManagementDetail",
        params: {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          adjustmentId,
        },
      });
    },
    async handleStockAdjusted() {
      // Refresh the stock adjustment list silently after modal is closed
      try {
        const clinicUrl = this.$route.params.clinicUrl;
        const branchUrl = this.$route.params.branchUrl;

        await this.fetchStockAdjustmentList({ clinicUrl, branchUrl });
      } catch (err) {
        console.error("Failed to refresh stock adjustment list:", err);
      }
    },
    clamp(bn) {
      const MAX_VALUE = 9999999999.99;
      const MIN_VALUE = -9999999999.99;
      const max = new BigNumber(MAX_VALUE);
      const min = new BigNumber(MIN_VALUE);
      if (bn.isGreaterThan(max)) return max;
      if (bn.isLessThan(min)) return min;
      return bn;
    },
    mapExcelColumns(excelData) {
      const columnMap = {
        "Product ID": "productId",
        รหัสสินค้า: "productNo",
        ชื่อสินค้า: "productName",
        จำนวนสต๊อกหลังปรับปรุง: "actualCount",
        หน่วยสินค้า: "unit",
      };
      return excelData.map(row => {
        const mapped = {};
        for (const [col, key] of Object.entries(columnMap)) {
          if (col in row) {
            mapped[key] = row[col];
          }
        }
        return mapped;
      });
    },
    validateExcelData(excelData) {
      if (!excelData?.length) return false;
      const requiredCols = ["Product ID", "จำนวนสต๊อกหลังปรับปรุง"];
      return requiredCols.every(col => col in excelData[0]);
    },
    mapProductToAdjustmentItem(product, excelRow) {
      const base = {
        productId: product.productId,
        productNoAndName: `${product.productCode} - ${product.productNameMain}`,
        imageUrl: product.imageUrl || null,
        productAvailableStock: product.productAvailableStock,
        productUnit: product.productUnit?.description ?? "",
        productUnitId: product.productUnit?.id ?? null,
        adjustmentAmount: 0,
        currentStockToAfterAdjustment: product.productAvailableStock,
      };

      if (!excelRow)
        return {
          item: base,
          error: `Product ${product.productCode} - ${product.productNameMain} not found in Excel`,
        };

      const raw = parseFloat(excelRow.actualCount);
      if (isNaN(raw))
        return {
          item: null,
          error: `Product ID ${product.productId}: ค่าจำนวนสต๊อกหลังปรับปรุงไม่ถูกต้อง`,
        };

      const actualCount = this.clamp(new BigNumber(raw));
      const current = new BigNumber(product.productAvailableStock || 0);
      const adjustmentAmount = this.clamp(actualCount.minus(current));

      return {
        item: {
          ...base,
          productAvailableStock: current.toNumber(),
          adjustmentAmount: adjustmentAmount
            .decimalPlaces(2, BigNumber.ROUND_DOWN)
            .toNumber(),
          currentStockToAfterAdjustment: actualCount
            .decimalPlaces(2, BigNumber.ROUND_DOWN)
            .toFixed(2),
        },
        error: null,
      };
    },
    buildAdjustmentItems(productList, excelData) {
      const errors = [];
      const items = [];

      productList
        .filter(
          p =>
            p.productStatus === Status.LOCKED ||
            p.productStatus === Status.ACTIVE
        )
        .forEach(product => {
          const excelRow = excelData.find(
            row =>
              String(row.productId).trim() === String(product.productId).trim()
          );

          const { item, error } = this.mapProductToAdjustmentItem(
            product,
            excelRow
          );
          if (error) errors.push(error);
          if (item) items.push(item);
        });

      return { items, errors };
    },

    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },
    async handleImportExcel(event) {
      const file = event.target.files[0];
      if (!file) return;

      const showError = () => {
        this.$refs.Dialog.showToast(
          "danger",
          "รูปแบบไฟล์ไม่ถูกต้อง กรุณาตรวจสอบและนำเข้าใหม่อีกครั้ง"
        );
        this.$refs.fileInput.value = "";
      };

      try {
        const XLSX = await import("xlsx");
        const buffer = await this.readFileAsArrayBuffer(file);

        const workbook = XLSX.read(buffer, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const rawExcelData = XLSX.utils.sheet_to_json(worksheet);

        if (!this.validateExcelData(rawExcelData)) return showError();

        const excelData = this.mapExcelColumns(rawExcelData);

        const { items, errors } = this.buildAdjustmentItems(
          this.productList,
          excelData
        );
        if (errors.length > 0) return showError();

        this.$refs.stockAdjustmentModal.show({
          unitList: this.getProductUnitList,
          physicalAdjustmentItems: items,
        });
      } catch (error) {
        console.error("Error importing Excel:", error);
        showError();
      } finally {
        this.$refs.fileInput.value = "";
      }
    },
    async handleExportExcel() {
      try {
        const clinicUrl = this.$route.params.clinicUrl;
        const branchUrl = this.$route.params.branchUrl;

        const result = await this.exportStockAdjustmentFile({
          clinicUrl,
          branchUrl,
        });

        const fileName = `Physical Count - ${
          new Date().toISOString().split("T")[0]
        }.xlsx`;

        // Create blob link to download
        const url = window.URL.createObjectURL(result);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Export error:", error);
        this.$refs.Dialog.showToast("danger", "เกิดข้อผิดพลาดในการ export");
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },
  },
};
</script>

<style scoped>
.tab-red-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #dd3333;
  border-radius: 50%;
  vertical-align: center;
}

.info-icon {
  color: #a3a4a6;
  cursor: pointer;
  font-size: 20px;
}

.info-icon:hover {
  color: #1976d2;
}

::v-deep #stockManagementTable {
  table-layout: fixed;
  width: 100%;
  overflow: visible;
}

::v-deep #stockManagementTable .text-center {
  text-align: center !important;
}

::v-deep #stockManagementTable thead tr th,
::v-deep #stockManagementTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #stockManagementTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #stockManagementTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

/* Code columns stay on one line even though the table wraps text */
::v-deep #stockManagementTable td.code-cell {
  white-space: nowrap !important;
  word-break: normal !important;
}

.btn-adjust-disabled:disabled {
  color: #ebebeb !important;
  border-color: #ebebeb !important;
}

.header-topic {
  display: flex;
  gap: 8px;
  align-items: center;
}

.outline-btn {
  border: 1px solid #5299d6;
  color: #5299d6;
  background: transparent;
  transition: all 0.2s ease;
}

.outline-btn:hover {
  background-color: #5299d6;
  color: #fff;
}

.ellipsis-text {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ::v-deep #stockManagementTable th[aria-colindex="7"],
::v-deep #stockManagementTable td[aria-colindex="7"] {
  text-align: center !important;
  padding: 8px !important;
  min-width: 50px;
} */

::v-deep #stockManagementTable th {
  white-space: nowrap;
}
</style>
